import { createFileRoute } from "@tanstack/react-router";
import { AssessmentChild } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/assessment/child/$sessionId")({
  head: () => seoHead({ title: "Child Assessment", noindex: true }),
  component: AssessmentChild,
});
